export default __webpack_public_path__ + "static/media/10.20fd34c0.png";